import React from "react";
import Chart from "react-apexcharts";

const KpiChartPreview = () => {
    const series = [41.3]; // Valor del gráfico (en porcentaje)

    // Cálculo de la posición de la aguja
    const calculateNeedlePosition = (value) => {
        // Rango de -120° a 120° para el gráfico
        const angle = (-120 + (240 * value) / 100) * (Math.PI / 180); // Convierte a radianes
        const radius = 130; // Radio (en píxeles, ajusta según el tamaño del gráfico)
        const centerX = 200; // Centro en píxeles (ajustar al tamaño del gráfico)
        const centerY = 200;

        // Calcula las coordenadas del extremo de la aguja
        const x2 = centerX + radius * Math.cos(angle);
        const y2 = centerY + radius * Math.sin(angle);

        return { x2, y2 };
    };

    const needlePosition = calculateNeedlePosition(series[0]);

    const options = {
        chart: {
            type: "radialBar",
            offsetY: -20,
        },
        plotOptions: {
            radialBar: {
                startAngle: -120, // Hace que el gráfico sea más cerrado
                endAngle: 120,
                hollow: {
                    margin: 10,
                    size: "70%", // Hace el gráfico más ancho
                },
                track: {
                    background: "#f4f4f4",
                    strokeWidth: "100%",
                },
                dataLabels: {
                    name: {
                        show: true,
                        fontSize: "18px",
                    },
                    value: {
                        offsetY: 10,
                        fontSize: "22px",
                        formatter: function (val) {
                            return `${val}%`;
                        },
                    },
                },
            },
        },
        colors: ["#FF4500", "#FFD700", "#32CD32"], // Gradiente de colores
        labels: ["Margin"],
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "horizontal",
                shadeIntensity: 0.5,
                gradientToColors: ["#FFD700", "#32CD32"], // Termina en verde
                stops: [0, 100],
            },
        },
        annotations: {
            shapes: [
                {
                    type: "line",
                    x1: "200px", // Centro del gráfico
                    y1: "200px",
                    x2: `${needlePosition.x2}px`, // Coordenada dinámica
                    y2: `${needlePosition.y2}px`, // Coordenada dinámica
                    strokeDashArray: 0,
                    strokeColor: "#000000",
                    strokeWidth: 3, // Ancho de la aguja
                },
            ],
        },
    };

    return (
        <div>
            <Chart
                options={options}
                series={series}
                type="radialBar"
                height={400} // Asegúrate de que el tamaño sea suficiente
                width={400}
            />
        </div>
    );
};

export default KpiChartPreview;
